module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_59-05c4ffbb9ce23577e4bf64d722c1d613.png";